import { render, staticRenderFns } from "./SousTypeDocumentSwitch.vue?vue&type=template&id=d24b330c&"
import script from "./SousTypeDocumentSwitch.vue?vue&type=script&lang=js&"
export * from "./SousTypeDocumentSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports